<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header bg-dark text-white d-flex align-items-center gap-2">
    <i class="bx bx-file-find bx-sm"></i>
    <strong>Referencias Documentales</strong>
    <span class="badge bg-light text-dark ms-auto">{{ documentReferences().length }}</span>
  </div>
  <div class="card-body p-0">
    <div class="list-group list-group-flush">
      @for (doc of documentReferences(); track doc.id) {
        <div class="list-group-item">
          <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
            <div>
              <strong>{{ getDocType(doc) }}</strong>
              @if (doc.status) {
                @let badge = getStatusBadge(doc.status);
                <span class="badge {{ badge.color }} ms-2">{{ badge.label }}</span>
              }
            </div>
            <small class="text-muted">{{ formatDate(getDate(doc)) }}</small>
          </div>

          @if (getDescription(doc)) {
            <div class="mt-1">
              <small class="text-muted">{{ getDescription(doc) }}</small>
            </div>
          }

          <!-- Adjuntos / PDFs -->
          @if (getAttachments(doc).length > 0) {
            <div class="mt-2 d-flex flex-wrap gap-2">
              @for (att of getAttachments(doc); track $index) {
                @if (att.url) {
                  <a
                    [href]="att.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="bx bx-download"></i>
                    {{ att.title || 'Descargar PDF' }}
                    @if (att.contentType) {
                      <span class="badge bg-light text-dark ms-1">{{ att.contentType }}</span>
                    }
                  </a>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
